// extracted by mini-css-extract-plugin
export default {"root":"MostPopularDays_root__6Vv0J","heading":"MostPopularDays_heading__s0DZO"};